export namespace RideStatusConstants {
  export const WILL_CALL: string = 'Will call';
  export const ON_DEMAND: string = 'On demand';
  export const PENDING: string = 'Pending';
  export const SCHEDULED: string = 'Scheduled';
  export const DRIVER_EN_ROUTE: string = 'Driver en route';
  export const PICKUP_ARRIVED: string = 'Pick-up arrived';
  export const IN_PROGRESS: string = 'In progress';
  export const DROP_OFF_ARRIVED: string = 'Drop-off arrived';
  export const COMPLETED: string = 'Completed';
  export const CANCELLED: string = 'Cancelled';
}

export enum RideStatusOrder {
  'Will call' = 0,
  'On demand' = 0,
  'Pending' = 0,
  'Scheduled' = 1,
  'Driver en route' = 2,
  'Pick-up arrived' = 3,
  'In progress' = 4,
  'Drop-off arrived' = 5,
  'Completed' = 6
}
